export const companyFilter = (state, props) => {
  const paramsCompanyCode = props.params && props.params.companyCode
  const companyCode = props.companyCode

  return paramsCompanyCode || companyCode
}
